import React, {useContext} from 'react';
import Tabs from './Tabs';
import LandingPage from '../../../Pages/LandingPage';
import {ThemeContext} from '../../../themes/ThemeProvider';
const IntermediateRepository = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = React.useState(0);
  const tabLabels = ['Staging Repository'];
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <LandingPage
      title={'Data Management'}
      showTabs={true}
      tabValue={value}
      handleTabChange={handleChange}
      allAntTabs={tabLabels}
    >
      <div className={`global-field-dash-board`}>
        <div className={` ${classes.cardStyleWhite}`}>
          <div className={classes.root}>
            <div className={classes.subContent}>
              <Tabs />
            </div>
          </div>
        </div>
      </div>
    </LandingPage>
  );
};

export default IntermediateRepository;
